"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const prop_types_1 = __importDefault(require("prop-types"));
const hooks_1 = require("../../hooks");
const LaunchDarklyFeatureFlagWrapper = ({ flagKey, children }) => {
    const { isOn: isFlagEnabled } = (0, hooks_1.useFeatureFlag)(flagKey);
    if (isFlagEnabled)
        return children;
    return null;
};
const LaunchDarklyExperimentWrapper = ({ flagKey, versionVariant, children }) => {
    const experiment = (0, hooks_1.useExperiment)(flagKey);
    if (experiment[`is${versionVariant}`])
        return children;
    return null;
};
const LaunchDarklyWrapper = ({ versionVariant, ...props }) => {
    if (versionVariant) {
        return (0, jsx_runtime_1.jsx)(LaunchDarklyExperimentWrapper, { versionVariant: versionVariant, ...props });
    }
    return (0, jsx_runtime_1.jsx)(LaunchDarklyFeatureFlagWrapper, { ...props });
};
LaunchDarklyWrapper.propTypes = {
    flagKey: prop_types_1.default.string.isRequired,
    versionVariant: prop_types_1.default.oneOf(['V0', 'V1', 'V2'])
};
exports.default = LaunchDarklyWrapper;
//# sourceMappingURL=launch-darkly-wrapper.js.map